import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMusicNote24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconMusicNote24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8.5 3.75A.75.75 0 0 1 9.25 3h11a.75.75 0 0 1 .75.75V17.5a3.5 3.5 0 1 1-1.5-2.873V8H10v9.5a3.5 3.5 0 1 1-1.5-2.873zM10 6.5h9.5v-2H10zm7.5 9a2 2 0 1 1 0 4 2 2 0 0 1 0-4m-11 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMusicNote24);
